import { render, staticRenderFns } from "./MyAddressSelect.vue?vue&type=template&id=ccb927fa&"
import script from "./MyAddressSelect.vue?vue&type=script&lang=js&"
export * from "./MyAddressSelect.vue?vue&type=script&lang=js&"
import style0 from "./MyAddressSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports